import React from 'react'
import Header from '../../component/Header'
import Footer from '../../component/Footer'
import Diploma from '../Diploma'
import CourseBCOM from '../CourseBCOM'

export default function LayoutCourseBCOM() {
    return (
        <div>
            <Header />
            <CourseBCOM />
            <Footer />
        </div>
    )
}
